import Html from "./html";
import RateLimiter from "./rate_limiter";

declare var window: any;

class Search {
    private debouncedLoadResults: (q: string) => void;

    constructor(
        protected html: Html,
        protected rateLimiter: RateLimiter
    ) {
        this.debouncedLoadResults = this.rateLimiter.debounce(this.loadResults.bind(this), 300);
    }

    init(): void {
        const searchInputEl = this.html.q('#searchInputMenu');

        if (!searchInputEl) {
            return;
        }
        
        searchInputEl.addEventListener('input', (e) => {
            const inputEl = e.target as HTMLInputElement;
            let q = inputEl.value.trim();
            this.debouncedLoadResults(q);
        });
    }

    
    loadResults(q: string): Promise<any> {
        const url = `/search-suggestions/?q=${encodeURIComponent(q)}`;

        return this.html.fetchText(url)
            .then(html => {
                const searchResultsEl = this.html.q('#searchInputMenuResults') as HTMLDivElement;

                if (!searchResultsEl) {
                    return;
                }

                this.html.writeHTML(searchResultsEl, html);
            })
            .catch(e => {
                console.log('Error loading data from server', e);
            });
    }
}

export default Search;